import styled from "styled-components";
import { Dispatch, SetStateAction } from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ProductSearchHistory } from "../../components/history/ProductSearchHistory";
import { SearchResults } from "../../components/searchResults/SearchResults";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import FixaSearch, {
  FixaSearchActions,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";
import { useTranslation } from "@coworker/locales";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

interface ProductSearchPagePresentationProps {
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  shouldHideSPRItems: boolean;
  shouldHideLocalCombinationItems: boolean;
  handleItemCardClick?: (item: Item) => void;
  itemCardRenderType?: SearchItemCardRenderType;
  shouldHideHistory?: boolean;
  shouldHideResults?: boolean;
  searchBarActions?: FixaSearchActions[];
  autoFocus?: boolean;
  isSearchFocused: boolean;
  isInteractingWithHistory: boolean;
  setIsInteractingWithHistory: Dispatch<SetStateAction<boolean>>;
  handleSearchQueryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearchQueryReset: () => void;
  handleSearchBlur: () => void;
  handleSearchFocus: () => void;
}

export const ProductSearchPagePresentation = ({
  searchQuery,
  setSearchQuery,
  handleItemCardClick = () => {},
  shouldHideSPRItems,
  itemCardRenderType = SearchItemCardRenderType.link,
  shouldHideLocalCombinationItems,
  shouldHideHistory = false,
  shouldHideResults = false,
  searchBarActions,
  autoFocus = true,
  isSearchFocused,
  setIsInteractingWithHistory,
  handleSearchQueryChange,
  handleSearchQueryReset,
  handleSearchBlur,
  handleSearchFocus,
}: ProductSearchPagePresentationProps) => {
  const { t } = useTranslation();
  return (
    <Container>
      <FixaSearch
        id="product-search"
        placeholder={t("searchBasicString")}
        onChange={handleSearchQueryChange}
        onClear={handleSearchQueryReset}
        value={searchQuery}
        autoFocus={autoFocus}
        actions={searchBarActions}
        onFocus={handleSearchFocus}
        onBlur={handleSearchBlur}
      />
      {!shouldHideHistory && isSearchFocused && (
        <div
          onMouseDown={() => setIsInteractingWithHistory(true)}
          onMouseUp={() => setIsInteractingWithHistory(false)}
          onMouseLeave={() => setIsInteractingWithHistory(false)}
        >
          <ProductSearchHistory
            hideHistory={searchQuery.length > 0}
            setSearchQuery={setSearchQuery}
          />
        </div>
      )}
      {!shouldHideResults && (
        <SearchResults
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleItemCardClick={handleItemCardClick}
          itemCardRenderType={itemCardRenderType}
          shouldHideSPRItems={shouldHideSPRItems}
          shouldHideLocalCombinationItems={shouldHideLocalCombinationItems}
        />
      )}
    </Container>
  );
};
